import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { OrderCourseOption } from "interfaces/front/business";
import { goErrorPage } from "lib/frontRouting";
import { FrontOrderService, UpdateCourseOptionInput } from "lib/service/client/FrontOrderService";
import { errorToast } from "lib/toast";
import { orderCourseOptionSchema } from "lib/validation/orderCourseOptionSchema";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { FrontDialogTitle } from "../../Form/FrontDialogTitle";
import { AaTextField } from "../../layout/aniale/AaTextField";

type Props = {
  orderCode: string;
  isOpen: boolean;
  orderCourseOption: OrderCourseOption;
  onClose: () => void;
  onUpdated: (query: UpdateCourseOptionInput) => void;
  detailId: number;
};
const OrderCourseOptionModal: FC<Props> = (props) => {
  const router = useRouter();
  return (
    <Dialog onClose={props.onClose} open={props.isOpen} fullWidth>
      <Formik<UpdateCourseOptionInput>
        enableReinitialize
        initialValues={{
          detail_id: props.detailId,
          question: props.orderCourseOption.question,
          id: props.orderCourseOption.id,
          value: props.orderCourseOption.input_value,
        }}
        onSubmit={async (query: UpdateCourseOptionInput, helpers: FormikHelpers<UpdateCourseOptionInput>) => {
          const service = new FrontOrderService(router);
          await service.updateCourseOption(
            props.orderCode,
            query,
            () => {
              props.onUpdated(query);
              helpers.setSubmitting(false);
            },
            (error) => {
              if (error?.order_error?.code === "had_ended") {
                props.onClose();
                errorToast("プロジェクトが掲載終了したため変更できませんでした。");
              } else if (error?.validation_error) {
                helpers.setErrors(error.validation_error);
              } else {
                goErrorPage(router);
              }
            }
          );
        }}
        validationSchema={orderCourseOptionSchema()}
      >
        {({ isSubmitting }): React.ReactNode => (
          <Form>
            <FrontDialogTitle title={props.orderCourseOption.question} onClose={props.onClose} />
            <DialogContent>
              <Field
                fullWidth
                component={AaTextField}
                variant="outlined"
                name="value"
                type="text"
                size="small"
                style={{ margin: "10px 0" }}
              />
            </DialogContent>
            <DialogActions>
              <Button disabled={isSubmitting} variant={"contained"} type="submit" color="primary" fullWidth>
                確定
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
export default OrderCourseOptionModal;
